<template>
    <main-content>
        <transactions-report-filter
            :action="filterAction"
            :exportExcel="exportToExcel"
        >
        </transactions-report-filter>

        <div>
            <kt-row>
                <kt-col lg="3" md="3" xs="12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__body" style="color: black; background-color: #fff">
                            <div class="text-center p-1">
                                <h6> {{ $t('label.statements_from') }}  {{ my_statements.from_date}}</h6>
                            </div>
                            <div class="text-center pt-1">
                                <h6> {{ $t('label.statements_to') }}  {{ my_statements.to_date}}</h6>
                            </div>
                        </div>
                    </div>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__body" style="color: black; background-color: #fff">
                            <h6> {{ $t('label.terminal_title') }}</h6>
                            <div class="text-center">
                                <h4 class="fix-margin">
                                    {{ my_statements.persian_name }}
                                </h4>
                            </div>
                        </div>
                    </div>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__body" style="color: black; background-color: #fff">
                            <h6> {{ $t('label.total_transactions') }}</h6>
                            <div class="text-center">
                                <h4 class="fix-margin">
                                    {{  my_statements.total_statements }}
                                    <span style="font-size: 1.5rem">
                                        {{ ' ' + $t('currency.rial')}}
                                    </span>
                                </h4>
                            </div>
                        </div>
                    </div>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__body" style="color: black; background-color: #fff">
                            <h6>{{ $t('label.succeeded_transactions_number') }}</h6>
                            <div class="text-center">
                                <h4 class="fix-margin">
                                    {{my_statements.total_success_transactions }}
                                </h4>
                            </div>
                        </div>
                    </div>
                </kt-col>
            </kt-row>
        </div>
        <div>
            <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
        </div>

    </main-content>
</template>

<script>
    import $ from 'jquery'
    import { ApiUrl } from '@/common/api.service'
    import columns from './datatable/statements-report-columns'
    import statementsReportFilter from './components/statements-report-filter'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import mainContent from '@/components/main-content'
    import {mapGetters} from "vuex";
    import store from '@/store'
    import axios from "axios";
    import toastr from "toastr";
    import { KTApp } from '@/plugins/core/app'
    import { i18n } from '@/plugins/i18n'

    export default {
        name: "gateway_statements_report",
        components: {
            mainContent,
            'transactions-report-filter': statementsReportFilter
        },
        data() {
            return {

                headerAction: {
                    left: '10px',
                    top: '10px',
                    position: 'absolute'
                },
                query: {
                    'shop_type': 'PF',
                    psp : this.$route.query.psp

                },
                gateway_id: this.$route.params.hashid,
            }
        },
        computed: {
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            },
            datatableProps() {
                const self = this
                return {
                    id: "datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {

                                url: ApiUrl.path(`gateway/gateway-statements/${this.gateway_id}`),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: (res) => {
                                    return res.data.data.data
                                },

                                params: {
                                    query: this.query,
                                },
                                success: function (res) {
                                    let params = {
                                        hashid: res.data.data.shop_id,
                                        query: {
                                            psp: self.$route.query.psp
                                        }
                                    }

                                            store.dispatch('gateway/fetchReportStatisticsStatements', params)

                                },


                            }

                        },
                        pageSize: 15,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,

                }
            },
            ...mapGetters('gateway', [
                'status', 'my_statements'
            ]),

        },
        methods: {
            updateReport(e, query) {
                query.reportUpdate = true
                this.query = query
                query.psp = this.$route.query.psp
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            },
            exportToExcel(e, query){
                let btn = $('#export_psp_transations_btn')
                KTApp.progress(btn)

                this.query = query
                query.psp = this.$route.query.psp

                axios({
                    url: ApiUrl.path(`gateway/admin/export-statements-report/${this.gateway_id}`),
                    method: 'GET',
                    params: this.query,
                    responseType: 'blob',
                }).then((response) => {
                    KTApp.unprogress(btn);
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'statements.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                }).catch(({response}) => {
                    this.toastr.error(i18n.t('message.an_error_accord'))
                    KTApp.unprogress(btn)
                })
            },
            filterAction(e, query) {
                query.reportUpdate = false
                console.log(query.date_to, query.date_from)
                if (query.date_from) {
                    var date_from = new Date(query.date_from);
                }
                if (query.date_to) {
                    var date_to = new Date(query.date_to);
                }
                if (date_to && date_from && date_from > date_to) {
                    this.toastr.error(i18n.t('message.error_my_statements'))
                    return;
                }
                this.query = query
                query.psp = this.$route.query.psp
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
                this.fetchReportStatisticsStatements(this.gateway_id)
            },
            fetchReportStatisticsStatements(hashid) {
                store.dispatch('gateway/fetchReportStatisticsStatements', hashid)
            }
        },
    }
</script>

<style>
</style>